import React from 'react'
import { DocumentCard } from '@/components/DocumentCard'
import { documents } from '@/config/documents'
import { Search, BookOpen, Layers } from 'lucide-react'

export const DocumentPage: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400 rounded-full mb-6">
          <BookOpen size={32} />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
          Documents List
        </h1>
        {/* <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
          探索我们的文档库，获取详细的使用指南、技术说明和最佳实践
        </p> */}
      </div>

      {/* Stats */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        <div className="bg-white rounded-xl p-6 border border-gray-200 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-600 rounded-lg mb-4">
            <BookOpen size={24} />
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-1">{documents.length}</div>
          <div className="text-sm text-gray-600">总文档数</div>
        </div>
        <div className="bg-white rounded-xl p-6 border border-gray-200 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 text-green-600 rounded-lg mb-4">
            <Layers size={24} />
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-1">
            {new Set(documents.map(doc => doc.category)).size}
          </div>
          <div className="text-sm text-gray-600">文档分类</div>
        </div>
        <div className="bg-white rounded-xl p-6 border border-gray-200 text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 text-purple-600 rounded-lg mb-4">
            <Search size={24} />
          </div>
          <div className="text-2xl font-bold text-gray-900 mb-1">
            {documents.flatMap(doc => doc.tags).length}
          </div>
          <div className="text-sm text-gray-600">标签总数</div>
        </div>
      </div> */}

      {/* Documents Grid */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">所有文档</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {documents.map((document) => (
            <DocumentCard key={document.id} document={document} />
          ))}
        </div>
      </div>

      {/* Empty State for when there are no documents */}
      {documents.length === 0 && (
        <div className="text-center py-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500 rounded-full mb-6">
            <BookOpen size={32} />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">暂无文档</h3>
          <p className="text-gray-600 dark:text-gray-400">文档正在准备中，敬请期待...</p>
        </div>
      )}
    </div>
  )
}
